import React from "react";

const Payment = () => {
  const testContent = "Payment settings here in the future.";

  return <h2>{testContent}</h2>;
};

export default Payment;
